//# sourceMappingURL=table.mjs.map
/// <reference types="./table.d.mts" />
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $mouse from "../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $events from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $layout from "../../ds/components/layout.mjs";
import * as $s from "../../ds/internals/styles/table.mjs";
import * as $utils from "../../ds/utils.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
} from "../../gleam.mjs";

class Fit extends $CustomType {}

class MinContent extends $CustomType {}

class Fraction extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Clamp extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

class Text extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Custom extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Header extends $CustomType {
  constructor(content, size) {
    super();
    this.content = content;
    this.size = size;
  }
}

class SubRow extends $CustomType {
  constructor(row, separator) {
    super();
    this.row = row;
    this.separator = separator;
  }
}

class Cell extends $CustomType {
  constructor(content, style, stop_propagation, class$) {
    super();
    this.content = content;
    this.style = style;
    this.stop_propagation = stop_propagation;
    this.class = class$;
  }
}

class NoRow extends $CustomType {}

class Row extends $CustomType {
  constructor(cells, hover, on_click, id) {
    super();
    this.cells = cells;
    this.hover = hover;
    this.on_click = on_click;
    this.id = id;
  }
}

class Headers extends $CustomType {
  constructor(headers) {
    super();
    this.headers = headers;
  }
}

class Rows extends $CustomType {
  constructor(rows) {
    super();
    this.rows = rows;
  }
}

class Footer extends $CustomType {
  constructor(disabled, elements) {
    super();
    this.disabled = disabled;
    this.elements = elements;
  }
}

function size_to_string(size) {
  if (size instanceof Fit) {
    return "auto";
  } else if (size instanceof MinContent) {
    return "min-content";
  } else if (size instanceof Fraction) {
    let value = size[0];
    return $int.to_string(value) + "fr";
  } else {
    let preferred = size[0];
    let value = size[1];
    return ((("clamp(0px, " + preferred) + ", ") + $int.to_string(value)) + "px)";
  }
}

function is_headers(node) {
  if (node instanceof Headers) {
    return true;
  } else if (node instanceof Rows) {
    return false;
  } else {
    return false;
  }
}

function is_rows(node) {
  if (node instanceof Headers) {
    return false;
  } else if (node instanceof Rows) {
    return true;
  } else {
    return false;
  }
}

function is_footer(node) {
  if (node instanceof Headers) {
    return false;
  } else if (node instanceof Rows) {
    return false;
  } else {
    return true;
  }
}

function compute_columns(lines) {
  if (lines instanceof Headers) {
    let $ = lines.headers;
    if ($ instanceof $Empty) {
      return new Error(undefined);
    } else {
      let headers$1 = $;
      let count = $list.length(headers$1);
      let _pipe = $list.map(headers$1, (h) => { return h.size; });
      let _pipe$1 = $list.map(_pipe, size_to_string);
      let _pipe$2 = $string.join(_pipe$1, " ");
      let _pipe$3 = ((_capture) => { return $pair.new$(count, _capture); })(
        _pipe$2,
      );
      return new Ok(_pipe$3);
    }
  } else if (lines instanceof Rows) {
    let $ = lines.rows;
    if ($ instanceof $Empty) {
      return new Error(undefined);
    } else {
      return new Error(undefined);
    }
  } else {
    return new Error(undefined);
  }
}

function show_row(tag, row, columns) {
  if (row instanceof NoRow) {
    return toList([]);
  } else {
    let on_click$1 = $option.map(
      row.on_click,
      (o) => { return (e) => { return o(e); }; },
    );
    let on_click$2 = $utils.optional_attribute(on_click$1, $events.on_click);
    let id = $utils.optional_attribute(
      row.id,
      (i) => { return $a.id("row-id-" + i); },
    );
    let _pipe = $s.tr(
      tag,
      columns,
      row.hover,
      toList([on_click$2, id]),
      $list.flat_map(
        row.cells,
        (cell) => {
          if (cell instanceof SubRow) {
            let $ = cell.row;
            if ($ instanceof NoRow) {
              return toList([$h.none()]);
            } else {
              let row$1 = $;
              let separator$1 = cell.separator;
              let content = show_row($h.div, row$1, columns);
              if (separator$1) {
                return listPrepend($s.semi_separator(columns), content);
              } else {
                return content;
              }
            }
          } else {
            let class$1 = $utils.optional_attribute(cell.class, $a.class$);
            let style$1 = $css.class$($option.unwrap(cell.style, toList([])));
            let _block;
            let $ = cell.stop_propagation;
            if ($) {
              _block = $utils.stop_propagation();
            } else {
              _block = $a.none();
            }
            let on_click$3 = _block;
            return toList([
              $s.tcell(
                style$1,
                toList([on_click$3, class$1]),
                toList([cell.content]),
              ),
            ]);
          }
        },
      ),
    );
    return $list.wrap(_pipe);
  }
}

function view_table(attrs, columns, headers, body, footer) {
  return $layout.column(
    toList([$layout.overflow("hidden")]),
    toList([]),
    toList([
      $s.table(
        columns,
        attrs,
        toList([
          (() => {
            if (headers instanceof Ok) {
              let $ = headers[0];
              if ($ instanceof Headers) {
                let $1 = $.headers;
                if ($1 instanceof $Empty) {
                  return $h.none();
                } else {
                  let headers$1 = $1;
                  return $s.thead(
                    columns,
                    toList([]),
                    toList([
                      $s.thr(
                        columns,
                        toList([]),
                        $list.map(
                          headers$1,
                          (header) => {
                            return $s.theader(
                              toList([]),
                              toList([
                                (() => {
                                  let $2 = header.content;
                                  if ($2 instanceof Text) {
                                    let title = $2[0];
                                    return $h.text(title);
                                  } else {
                                    let element = $2[0];
                                    return element;
                                  }
                                })(),
                              ]),
                            );
                          },
                        ),
                      ),
                    ]),
                  );
                }
              } else if ($ instanceof Rows) {
                return $h.none();
              } else {
                return $h.none();
              }
            } else {
              return $h.none();
            }
          })(),
          (() => {
            if (body instanceof Ok) {
              let $ = body[0];
              if ($ instanceof Headers) {
                return $h.none();
              } else if ($ instanceof Rows) {
                let $1 = $.rows;
                if ($1 instanceof $Empty) {
                  return $h.none();
                } else {
                  let rows = $1;
                  let _pipe = $list.flat_map(
                    rows,
                    (_capture) => { return show_row($h.tr, _capture, columns); },
                  );
                  let _pipe$1 = $list.intersperse(_pipe, $s.separator(columns));
                  return ((_capture) => {
                    return $s.tbody(columns, toList([]), _capture);
                  })(_pipe$1);
                }
              } else {
                return $h.none();
              }
            } else {
              return $h.none();
            }
          })(),
        ]),
      ),
      (() => {
        if (footer instanceof Ok) {
          let $ = footer[0];
          if ($ instanceof Headers) {
            return $h.none();
          } else if ($ instanceof Rows) {
            return $h.none();
          } else {
            let disabled = $.disabled;
            let elements = $.elements;
            if (disabled) {
              return $h.none();
            } else {
              return $s.tfoot(columns[0], toList([]), elements);
            }
          }
        } else {
          return $h.none();
        }
      })(),
    ]),
  );
}

export function table(attrs, children) {
  let headers$1 = $list.find(children, is_headers);
  let body$1 = $list.find(children, is_rows);
  let footer$1 = $list.find(children, is_footer);
  let _pipe = $result.try$(headers$1, compute_columns);
  let _pipe$1 = $result.try_recover(
    _pipe,
    (_) => { return $result.try$(body$1, compute_columns); },
  );
  let _pipe$2 = $result.map(
    _pipe$1,
    (_capture) => {
      return view_table(attrs, _capture, headers$1, body$1, footer$1);
    },
  );
  return $result.lazy_unwrap(_pipe$2, $h.none);
}

export function headers(headers) {
  return new Headers(headers);
}

export function header(title) {
  return new Header(new Text(title), new Fraction(1));
}

/**
 * A header cell rendering arbitrary content (e.g. a "select all" checkbox)
 * instead of a plain text title.
 */
export function custom_header(element) {
  return new Header(new Custom(element), new Fraction(1));
}

export function fit(header) {
  return new Header(header.content, new Fit());
}

export function fraction(header, fr) {
  return new Header(header.content, new Fraction(fr));
}

export function min_content(header) {
  return new Header(header.content, new MinContent());
}

export function clamp(header, preferred, max_width) {
  return new Header(header.content, new Clamp(preferred, max_width));
}

export function body(rows) {
  return new Rows(rows);
}

export function row(cells) {
  return new Row(cells, true, new None(), new None());
}

export function hover(row, value) {
  if (row instanceof NoRow) {
    return row;
  } else {
    return new Row(row.cells, value, row.on_click, row.id);
  }
}

export function on_click(row, on_click) {
  if (row instanceof NoRow) {
    return row;
  } else {
    return new Row(
      row.cells,
      row.hover,
      new Some(
        (event) => {
          on_click(event);
          return undefined;
        },
      ),
      row.id,
    );
  }
}

export function row_id(row, id) {
  if (row instanceof NoRow) {
    return row;
  } else {
    return new Row(row.cells, row.hover, row.on_click, new Some(id));
  }
}

export function cell(content) {
  return new Cell(content, new None(), false, new None());
}

export function sub_row(row) {
  return new SubRow(row, true);
}

export function separator(cell, value) {
  if (cell instanceof SubRow) {
    return new SubRow(cell.row, value);
  } else {
    return cell;
  }
}

export function none() {
  return new NoRow();
}

export function stop_cell_propagation(cell) {
  if (cell instanceof SubRow) {
    return cell;
  } else {
    return new Cell(cell.content, cell.style, true, cell.class);
  }
}

export function style(cell, styles) {
  if (cell instanceof SubRow) {
    return cell;
  } else {
    return new Cell(
      cell.content,
      (() => {
        let _pipe = cell.style;
        let _pipe$1 = $option.unwrap(_pipe, toList([]));
        let _pipe$2 = $list.append(_pipe$1, styles);
        return new Some(_pipe$2);
      })(),
      cell.stop_propagation,
      cell.class,
    );
  }
}

export function span(cell, span) {
  return style(cell, toList([$css.grid_column("span " + $int.to_string(span))]));
}

export function background(cell, background) {
  return style(cell, toList([$css.background(background)]));
}

export function justify(cell, justify) {
  return style(cell, toList([$css.justify_self(justify)]));
}

export function class$(cell, class$) {
  if (cell instanceof SubRow) {
    return cell;
  } else {
    return new Cell(
      cell.content,
      cell.style,
      cell.stop_propagation,
      new Some(class$),
    );
  }
}

export function padding(cell, padding) {
  return style(cell, toList([$css.padding($length.px(padding))]));
}

export function footer(disabled, elements) {
  return new Footer(disabled, elements);
}

function empty_cell(empty_text) {
  return $s.empty_cell($s.empty_text_content($h.text(empty_text)));
}

export function empty_table(empty_text, nb_columns) {
  return body(
    toList([
      (() => {
        let _pipe = row(
          toList([
            (() => {
              let _pipe = cell(empty_cell(empty_text));
              return span(_pipe, nb_columns);
            })(),
          ]),
        );
        return hover(_pipe, false);
      })(),
    ]),
  );
}
